export class Question {
  body!: string
}